import { OnlyOfficeEditor } from "@/components/common/OnlyOfficeEditor.tsx";
import { Form } from "@/components/core/forms/form.tsx";
import { useForm } from "react-hook-form";
import { Panel, PanelGroup, PanelResizeHandle } from "react-resizable-panels";
import { Button } from "../core/buttons/button";

export default function CaseCreateEditorModal({
	handleSubmit,
}: { handleSubmit: values }) {
	const form = useForm({
		defaultValues: {
			name: "",
		},
	});

	return (
		<Form {...form}>
			<div className="flex flex-col w-full">
				<div className="flex flex-row items-center justify-between w-full h-[50px] px-4 bg-slate-50 border-b border-slate-200">
					<span className="text-base font-bold text-foreground-dark">
						Create File
					</span>
					<div className="inline-flex flex-row w-auto gap-3"></div>
				</div>
				<div className="flex grow shrink flex-row w-full h-full">
					<PanelGroup
						className="flex flex-row grow w-full"
						direction="horizontal"
					>
						<Panel
							defaultSize={10}
							minSize={10}
							className="flex flex-col shrink-0 grow p-4 max-w-[420px]"
						>
							Create your file here.
							<div className="flex flex-row w-full gap-2 mt-auto">
								<Button className="w-full" variant="ghost">
									Cancel
								</Button>
								<Button className="w-full" onClick={handleSubmit}>
									Submit
								</Button>
							</div>
						</Panel>

						<PanelResizeHandle className="group flex justify-center items-center w-[12px] border-r border-l border-border/50 bg-white">
							<div className="inline-flex w-[4px] h-[40px] rounded-sm bg-foreground/50 group-hover:bg-foreground/90" />
						</PanelResizeHandle>

						<Panel
							defaultSize={65}
							minSize={10}
							className="flex flex-col shrink grow w-full"
						>
							<OnlyOfficeEditor />
						</Panel>
					</PanelGroup>
				</div>
			</div>
		</Form>
	);
}
